/**
 * Task Facade
 *
 * Simplified, stable API for presentation layer to interact with task operations.
 * Abstracts away orchestration complexity.
 * @agentic connections
 */

import type { MedplumClient } from "@medplum/core";
import type { Patient, Task } from "@medplum/fhirtypes";
import { upsertTask } from "@benchmark/core/actions";
import type { TaskFormData } from "@benchmark/core/types";

/**
 * Facade for task operations. Provides stable API for create/update.
 * @agentic connections
 */
export class TaskFacade {
  constructor(private medplum: MedplumClient) {}

  /**
   * Create or update a task.
   * @agentic connections
   */
  async upsert(
    formData: TaskFormData,
    patient?: Patient,
    existingTask?: Task,
  ): Promise<Task> {
    return await upsertTask(this.medplum, {
      formData,
      patient,
      existingTask,
    });
  }
}

/**
 * Creates a task facade instance bound to a MedplumClient.
 * @agentic connections
 */
export function createTaskFacade(medplum: MedplumClient): TaskFacade {
  return new TaskFacade(medplum);
}
